import {Cureus} from '../Cureus';

Cureus.NewsroomCarousel = {};

//= require_tree ./NewsroomCarousel